import { ApiCallResultStatus } from 'store/apiCallResultStatus';

import { IAlertDetails, IAlerts } from './alerts.types';

export interface IAlertsState {
  allAlerts: IAlerts;
  dashboardAlerts: IAlerts;
  alertDetailsMap: { [id: string]: IAlertDetails };
}

export function getDefaultAlertsState(): IAlertsState {
  return {
    allAlerts: {
      alertIds: [],
      fetchPageApiStatus: ApiCallResultStatus.DEFAULT,
      fetchPageError: undefined,
      paginationData: undefined,
    },
    dashboardAlerts: {
      alertIds: [],
      fetchPageApiStatus: ApiCallResultStatus.DEFAULT,
      fetchPageError: undefined,
      paginationData: undefined,
    },
    alertDetailsMap: {},
  };
}
